import { useEffect, useState } from "react";
import { fetchLaunchReadiness } from "../../../services/automapBuyerLaunchApi";
import { READINESS_STATUS_LABELS } from "../../../constants/automapBuyerLaunchConstants";
import { LaunchShell } from "./AdminLaunchShared";

export default function AdminLaunchReadinessPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLaunchReadiness().then(setPayload).finally(() => setLoading(false));
  }, []);

  return (
    <LaunchShell
      active="readiness"
      title="Buyer launch readiness"
      description="Checklist antes de enviar tráfico pagado."
      viewEvent="launch_readiness_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {!loading && payload ? (
        <>
          <p>
            Estado: <strong>{READINESS_STATUS_LABELS[payload.status] || payload.status}</strong> · Score:{" "}
            {payload.score}/100
          </p>
          {payload.sections?.map((section) => (
            <section key={section.id} className="dealer-state-box">
              <h3>
                {section.label} {section.complete ? "✓" : "○"}
              </h3>
              <ul>
                {section.items.map((item) => (
                  <li key={item.key}>
                    {item.complete ? "✓" : "○"} {item.label}
                    {item.current != null ? ` (${item.current}/${item.target ?? "—"})` : ""}
                  </li>
                ))}
              </ul>
            </section>
          ))}
          {payload.blockers?.length ? (
            <section className="dealer-state-box">
              <h3>Blockers</h3>
              <ul>
                {payload.blockers.map((b) => (
                  <li key={b.key}>{b.label}</li>
                ))}
              </ul>
            </section>
          ) : null}
        </>
      ) : null}
    </LaunchShell>
  );
}
